import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'
import './Contact.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class Contact extends Component {
  render() {
    return (
      <div className="container">
        <p className="getInContact">GET IN CONTACT:</p>
        {/* <div id="contact" className="footer"> */}
        <a className="contactLine" href="mailto:MarkMoellerUVA@gmail.com">
          <FontAwesomeIcon className="fas fa-envelope" icon="envelope" />
          MarkMoellerUVA@gmail.com
        </a>
        <a
          className="contactLine"
          href="https://www.dropbox.com/s/c0sykzbo18c2vft/MarkMoellerResume2021.pdf?dl=0"
          target="_blank"
        >
          <FontAwesomeIcon className="fas fa-file-alt" icon="file-alt" />
          Resume
        </a>
        {/* </div> */}
        <p>Mark Moeller &copy;2019</p>
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/Contact.js